<template>
  <component :is="level" :class="[fontColor]">
    <slot/>
  </component>
</template>

<script>
/**
 * Headings are used as the titles of each major section of a page in the
 * interface. For example, templates generally use headings as their title.
 * Heading element provides an option to change the level of the heading.
 */
export default {
  name: "Heading",
  status: "prototype",
  release: "1.0.0",
  props: {
    /**
     * The heading level used for the heading.
     * `h1, h2, h3, h4, h5, h6`
     */
    level: {
      type: String,
      default: "h1",
      validator: value => {
        return value.match(/(h1|h2|h3|h4|h5|h6)/)
      },
    },
    color: {
      type: String,
      default: ""
    },
  },
  computed: {
    fontColor: function () {
      switch(this.color) {
        case 'highlight': return 'fColorHighlight';
        case 'grey': return 'fColorGrey';
        default: return '';
      }
    }
  }
}
</script>

<style scoped>
h1 {
	font-size: 1.5em;
	font-weight: 400;
	margin: 0 0 5px 0;
	letter-spacing: 2px;
}
h2 {
	font-size: 1.4em;
	font-weight: 400;
	margin-top: 8px;
	letter-spacing: 1px;
}
h3 {
  font-size: 1.3em;
  font-weight: 400;
}
h4 {
  font-size: 1.2em;
  font-weight: 400;
}
h5 {
  font-size: 1.05em;
  font-weight: 400;
}
h6 {
  font-size: 1.0em;
  font-weight: 400;
}
</style>
